module.exports = __webpack_public_path__ + "assets/img/97eaabad97ac5869795cfc6c0c26a90a.png";